import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { WizzardCollapseService } from './wizzard-collapse.service';

import { WizzardCollapseComponentsModule } from './components';

import { WizzardCollapseComponent } from './wizzard-collapse.shared.component';

@NgModule({
    declarations: [
        WizzardCollapseComponent
    ],
    imports: [
        CommonModule,
        WizzardCollapseComponentsModule,
    ],
    exports: [
        WizzardCollapseComponent
    ],
    providers: [
        WizzardCollapseService
    ]
})
export class WizzardCollapseModule { }
